/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import { OrmService, Schema } from '../schema/orm.service';
import { AbstractGenFirestoreGroupService } from '@res/ngg-core';
@Injectable({
  providedIn: 'root',
})
export class AddressFirestoreService extends AbstractGenFirestoreGroupService<Schema, 'users', 'addresses'> {
  // addressOrm = inject(OrmService).usersOfAddressCollection;
  constructor() {
    super(inject(OrmService).groupsOfaddress, inject(OrmService).addressthroughtUsr);
  }

  // async UpdateAddress(
  //   parentId: AddressSchema['Id'],
  //   id: AddressSchema['Ref'],
  //   updateArg: SchemaKeys['UpdateArg']
  // ): Promise<TypesaurusCoreDoc<Def> | null> {
  //   const parent = await this.addressOrm.query((a) => {
  //     return a.docId()
  //   });
  //   parent[0].update();
  // }
}
